module.exports = __webpack_public_path__ + "img/rouded-division-icon.edf294f6.svg";